import { enumToStaticValue } from '@/utils'

export enum ItemDeterminationType {
  SALE = 'SALE',
  STOCK = 'STOCK'
}

export const itemDeterminationTypes = enumToStaticValue(ItemDeterminationType, 'item-determination-type')
